module.exports = __webpack_public_path__ + "static/img/propuestas-2.a0108d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/propuestas-2.jpg
// module id = wYg8
// module chunks = 1